import React from "react";

export function VoltixLogo({ className = "", size = 32, variant = "auto" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="voltix-logo">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="VOLTIX">
        <defs>
          <linearGradient id="voltix-grad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#0066FF" />
            <stop offset="1" stopColor="#00E5FF" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="46" height="46" rx="12" stroke="url(#voltix-grad)" strokeWidth="2" fill="none" />
        {/* Stylized "V" with lightning bolt integrated */}
        <path
          d="M11 12 L20 34 L24 28 L22 28 L28 18 L26 18 L32 12 L26 22 L30 22 L24 34 L26 34 L37 12"
          stroke="url(#voltix-grad)"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span className="font-display font-extrabold tracking-tight text-2xl">
        VOLT<span className="gradient-text">IX</span>
      </span>
    </div>
  );
}

export function VoltixMark({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="voltix-mark-grad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0066FF" />
          <stop offset="1" stopColor="#00E5FF" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="12" stroke="url(#voltix-mark-grad)" strokeWidth="2" fill="none" />
      <path d="M11 12 L20 34 L24 28 L22 28 L28 18 L26 18 L32 12 L26 22 L30 22 L24 34 L26 34 L37 12" stroke="url(#voltix-mark-grad)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
